// src/modules/Scheduling/shared/availability/day-conversions.ts
var ALL_DAYS = [
	"sunday",
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday"
];
function daysArrayToWeek(days) {
	const selected = new Set(days ?? []);
	return ALL_DAYS.reduce((week, day) => {
		week[day] = selected.has(day);
		return week;
	}, {});
}
function weekToDaysArray(week) {
	return ALL_DAYS.filter((day) => week[day]);
}
export { daysArrayToWeek, weekToDaysArray };

//# sourceMappingURL=day-conversions.js.map